
export function useFormatVariation(){
    function $getVariationName(attributes){
        let attr = attributes.map(elm => elm.name)
        return attr.join(' & ')
    }


    return {$getVariationName}
}